export interface ComparisonRow {
  feature: string;
  basetaoResource: string;
  normalSearch: string;
}

export const comparisonData: ComparisonRow[] = [
  { feature: 'Product Organization', basetaoResource: 'Advanced categories with spreadsheet links', normalSearch: 'Random scattered results' },
  { feature: 'Buying Guides', basetaoResource: 'Detailed step-by-step instructions', normalSearch: 'Limited or outdated information' },
  { feature: 'Shipping Information', basetaoResource: 'Methods, costs, and optimization tips', normalSearch: 'Usually missing or incomplete' },
  { feature: 'Comparison Tables', basetaoResource: 'Side-by-side product analysis', normalSearch: 'Rarely available' },
  { feature: 'Safety Education', basetaoResource: 'Comprehensive trust and safety guidance', normalSearch: 'Limited or absent' },
  { feature: 'QC Photo Guidance', basetaoResource: 'Detailed inspection workflow', normalSearch: 'Not covered' },
  { feature: 'Discount & Coupon Info', basetaoResource: 'Updated savings strategies', normalSearch: 'Scattered across forums' },
];